import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  userGroups: [],
  userGroupsLoading: false,
  pagination: {},
  userGroup: {},
  error: {},
  loading: false,
  fetchedAddItem: false,
  fetchedRemoveParent: false,
  fetchingDeleteUserGroup: false,
  fetchedDeleteUserGroupSuccess: false,
  updateUserGroupSuccess: false,
  onboarding: {
    exitOnboarding: false,
    currentGroup: '',
    exitStep: false,
    lastStep: false,
    position: 0,
    errors: {},
    steps: {},
  },
};

const userGroupsReducer = createReducer(initialState)({
  [types.FETCH_USERS_GROUPS_REQUEST]: (state) => {
    return {
      ...state,
      userGroupsLoading: true,
    };
  },
  [types.FETCH_USERS_GROUPS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      userGroups: payload?.data || [],
      pagination: payload?.pagination || {},
      userGroupsLoading: false,
    };
  },
  [types.FETCH_USERS_GROUPS_FAILED]: (state, { error }) => {
    return {
      ...state,
      userGroupsLoading: false,
      error: {
        list: error,
      },
    };
  },
  // ADD ITEM TO USER GROUP
  [types.FETCH_ADD_ITEM_TO_USER_GROUP_REQUEST]: (state) => {
    return {
      ...state,
      fetchedAddItem: false,
      loading: true,
    };
  },
  [types.FETCH_ADD_ITEM_TO_USER_GROUP_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchedAddItem: true,
      loading: false,
    };
  },
  [types.FETCH_ADD_ITEM_TO_USER_GROUP_FAILED]: (state, { error }) => {
    return {
      ...state,
      loading: false,
      error: {
        addItem: error,
      },
    };
  },
  // REMOVE PARENT FROM USER GROUP
  [types.FETCH_REMOVE_PARENT_FROM_USER_GROUP_REQUEST]: (state) => {
    return {
      ...state,
      fetchedRemoveParent: false,
      loading: true,
      error: null,
    };
  },
  [types.FETCH_REMOVE_PARENT_FROM_USER_GROUP_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchedRemoveParent: true,
      loading: false,
    };
  },
  [types.FETCH_REMOVE_PARENT_FROM_USER_GROUP_FAILED]: (state, { payload }) => {
    return {
      ...state,
      fetchedRemoveParent: false,
      loading: false,
      error: {
        removeItem: payload.errors,
      },
    };
  },

  // ONBOARDING CHANGE POSITION
  [types.CHANGE_POSITION]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        position: payload.position,
      },
    };
  },
  // RESET ONBOARDING
  [types.RESET_ONBOARDING]: (state) => {
    return {
      ...state,
      onboarding: {
        exitOnboarding: false,
        currentGroup: '',
        exitStep: false,
        lastStep: false,
        position: 0,
        errors: {},
        steps: {},
      },
    };
  },

  [types.SET_EXIT]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        [payload.type]: payload.exit,
      },
    };
  },
  // CREATE USER GROUP
  [types.FETCH_CREATE_USER_GROUP_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      onboarding: {
        ...state.onboarding,
        errors: {},
      },
    };
  },
  [types.FETCH_CREATE_USER_GROUP_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      updateUserGroupSuccess: true,
      onboarding: {
        ...state.onboarding,
        steps: {
          ...state.onboarding.steps,
          [payload.step]: payload.data,
        },
      },
    };
  },
  [types.FETCH_CREATE_USER_GROUP_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      onboarding: {
        ...state.onboarding,
        errors: payload?.errors || {},
      },
    };
  },
  [types.RESET_UPDATE_USER_GROUP]: (state) => {
    return {
      ...state,
      loading: false,
      updateUserGroupSuccess: false,
    };
  },

  // DELETE USER GROUP
  [types.DELETE_USER_GROUP_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchingDeleteUserGroup: true,
    };
  },
  [types.DELETE_USER_GROUP_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      fetchingDeleteUserGroup: false,
      fetchedDeleteUserGroupSuccess: true,
    };
  },
  [types.DELETE_USER_GROUP_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      error: payload?.errors || {},
      fetchingDeleteUserGroup: false,
      fetchedDeleteUserGroupSuccess: false,
    };
  },
  [types.RESET_DELETE_USER_GROUP]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      fetchingDeleteUserGroup: false,
      fetchedDeleteUserGroupSuccess: false,
    };
  },

  // GET USER GROUP BY ID
  [types.FETCH_USER_GROUP_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      userGroup: {},
    };
  },
  [types.FETCH_USER_GROUP_BY_ID_SUCCESS]: (state, { payload, page }) => {
    const data =
      page === 'details'
        ? { userGroup: payload }
        : {
            onboarding: {
              ...state.onboarding,
              steps: {
                ...state.onboarding.steps,
                details: payload,
              },
              errors: {},
            },
          };
    return {
      ...state,
      loading: false,
      ...{ ...data },
    };
  },
  [types.FETCH_USER_GROUP_BY_ID_FAILED]: (state, { error }) => {
    return {
      ...state,
      loading: false,
      vehicle: {},
      errors: {
        vehicles: error,
      },
    };
  },

  // UPDATE STEPS LIST
  [types.UPDATE_STEPS_LISTS_REQUEST]: (state, { payload }) => {
    const { onboarding } = state;
    const { step, listName } = payload;

    return {
      ...state,
      loading: true,
      onboarding: {
        ...onboarding,
        steps: {
          ...onboarding.steps,
          [step]: {
            ...onboarding.steps[step],
            [listName]: {
              ...onboarding?.steps?.[step]?.[listName],
              list: [],
              loading: true,
            },
          },
        },
        errors: {},
      },
    };
  },
  [types.UPDATE_STEPS_LISTS_SUCCESS]: (state, { payload }) => {
    const { onboarding } = state;
    const { step, listName } = payload;

    return {
      ...state,
      loading: false,
      onboarding: {
        ...onboarding,
        steps: {
          ...onboarding.steps,
          [step]: {
            ...onboarding.steps[step],
            [listName]: {
              loading: false,
              ...payload.data,
            },
          },
        },
      },
    };
  },
  [types.UPDATE_STEPS_LISTS_FAILED]: (state, { payload }) => {
    const { onboarding } = state;
    const { step, listName, errors } = payload;
    return {
      ...state,
      loading: false,
      onboarding: {
        ...onboarding,
        steps: {
          ...onboarding.steps,
          [step]: {
            ...onboarding.steps[step],
            [listName]: {
              ...state?.onboarding?.steps?.[step]?.[listName],
              loading: false,
            },
          },
        },
        errors: errors,
      },
    };
  },
});

export default userGroupsReducer;
